import { Link } from "react-router-dom";
import { Phone, MessageSquare } from "lucide-react";
import { PHONE, TEL, SMS } from "../../lib/data";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 pt-24">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <Reveal className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <img src="/img/logo-sm.webp" alt="Bridgeway Auto" className="h-20 w-auto" />
          <p className="mt-6 max-w-md text-zinc-300">Mobile mechanic. We bring the shop to you. Insured · $85/hr labor · travel fee $1 per mile · parts extra.</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:col-span-5 lg:justify-end">
          <a href={TEL} data-testid="footer-call-link" className="btn-neon flex items-center justify-center gap-2 rounded-full px-7 py-4 text-sm font-bold uppercase tracking-wider text-white"><Phone className="h-4 w-4" /> Call {PHONE}</a>
          <a href={SMS} data-testid="footer-text-link" className="flex items-center justify-center gap-2 rounded-full border border-white/20 px-7 py-4 text-sm font-bold uppercase tracking-wider text-white hover:border-[var(--mag)]"><MessageSquare className="h-4 w-4" /> Text us</a>
        </div>
      </Reveal>
      <div className="mt-16 flex flex-col justify-between gap-4 border-t border-white/10 py-8 text-sm text-zinc-400 sm:flex-row">
        <span>© 2026 Bridgeway Auto Mobile Mechanic</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">Owner login</Link>
      </div>
    </div>
    <div aria-hidden className="font-race pointer-events-none select-none whitespace-nowrap text-center text-[22vw] leading-[0.75] text-chrome opacity-[0.12]">Bridgeway</div>
  </footer>
);
